import type { IResourceConfig } from '@/Core/Contracts/UI/Resource'
import { GetResourceTask } from './GetResourceTask'
import { GetRestUrlTask } from './GetRestUrlTask'

/**
 * Отримує REST URL для ресурсу за його ключем або конфігурацією
 *
 * @param resource - ключ ресурсу (string) або об'єкт конфігурації (IResourceConfig)
 * @param type - тип операції (getCollection, get, post, patch, delete тощо)
 * @param replaceParams - параметри для заміни в URI
 * @returns готовий URI або null якщо ресурс не знайдено або не має restUrl
 *
 * @example
 * ```typescript
 * // Отримати URL для колекції
 * const collectionUrl = GetRestUrlByResourceTask('products', 'getCollection')
 *
 * // Отримати URL для конкретного елемента
 * const itemUrl = GetRestUrlByResourceTask('products', 'get', { id: '123' })
 *
 * // Використати з об'єктом конфігурації
 * const customUrl = GetRestUrlByResourceTask(productResource, 'patch', { id: '456' })
 * ```
 */
export const GetRestUrlByResourceTask = (
    resource: string | IResourceConfig,
    type: string = 'getCollection',
    replaceParams: Record<string, any> = {}
): string | null => {
    const resolvedResource = GetResourceTask(resource)

    if (!resolvedResource || !resolvedResource.restUrl) {
        return null
    }

    return GetRestUrlTask(resolvedResource.restUrl, type, replaceParams)
}
